import React from "react";
import CustomFormSelect from "../CustomSelectControl";
import "./DateSelect.scss";
import { defaultOptions } from "./helper";

interface CustomFormSelectProps {
  value?: string; // for controlled
  onChange?: (event: React.ChangeEvent<HTMLSelectElement>) => void; // for controlled
  defaultValue?: string; // for uncontrolled
  className?: string;
  children?: React.ReactNode | any; // for other options than the default
  noBorder?: boolean;
}

const DateSelect: React.FC<CustomFormSelectProps> = ({
  value,
  defaultValue,
  onChange,
  className,
  children = defaultOptions,
  noBorder,
}) => {
  const selectValue = value !== undefined ? value : defaultValue;

  return (
    <CustomFormSelect
      as="select"
      value={selectValue}
      onChange={onChange}
      className={`${className} date-select-container ${noBorder && "noBorder"}`}
      defaultValue={defaultValue}
    >
      {children}
    </CustomFormSelect>
  );
};

export default DateSelect;
